import { ChangeDetectionStrategy, Component } from '@angular/core';

import { DefautHistoricPricesComponent } from '../../../lazy-modules/historicPricesLazy/components/historicPrices/default-historic-prices.component';
import { LocaleDirective } from '../../directives/locale.directive';
import { PriceOddsButtonComponent } from '../priceOddsButton/price-odds-button.component';
import { PriceOddsSAClassDirective } from './price-odds-class-sa.directive';
import { PriceOddsSADisabledDirective } from './price-odds-disabled-sa.directive';
import { PriceOddsSAValueDirective } from './price-odds-value-sa.directive';

@Component({
    selector: 'price-odds-button-sa',
    templateUrl: './price-odds-button-sa.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PriceOddsSAClassDirective, PriceOddsSAValueDirective, PriceOddsSADisabledDirective, DefautHistoricPricesComponent, LocaleDirective],
})
export class PriceOddsButtonSAComponent extends PriceOddsButtonComponent {}
